export enum BillStatus {
  All = 'all',
  Draft = 'draft',
  Overdue = 'overdue',
  Paid = 'paid',
  PartiallyPaid = 'partially_paid',
  Unpaid = 'unpaid',
  Voided = 'voided',
}
